module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAOCAYAAAAfSC3RAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAADYSURBVHgBrZJLDoIwEIaHxkmIK5YgLnoEvAk3MJ5A97ogMaI7j8IVvIHcoGoaXbjBHQRDbTWo4aUY/6Rp55/50ukDoEbW6ji2fD6py2tVpr3gjgDYqnUKMDhP+2GxhhQNc8mohII8RtAC02P0I0gyVNBboaAEMWgEbZ+v5eRAWY71yJVBa35wMwGubHOnxnO/PJY50+fD3K+8HHVO2TK7g4LQ06y3b2y1jX4GO1WmnkAUI4zUOr4mF/inNMNjho7otqLSdNPpIqqvRdtwgBgRob3e7FsJAeEN22dCBaU2a6gAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon/export-data.png
// module id = x8Gr
// module chunks = 46